<template>
  <el-dialog
    title="视频播放"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
    custom-class="video_call_modal"
    :append-to-body="true"
    id="orderlist"
  >
    <video
      ref="video"
      id="video"
      width="200px"
      height="150px"
      controls
      autoplay
      playsinline
      muted="muted"
    >
      <source :src="orderInfo.installVideoUrl" type="video/mp4" />
    </video>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      orderInfo: {},
    };
  },

  methods: {
    init(item) {
      this.dialogVisible = true;
      this.orderInfo = item || {};
    },
    close() {
      this.dialogVisible = false;
    },
    // 模态框关闭回调
    handleClose() {
      this.dialogVisible = false;
      console.log("模态框关闭");
    },
  },
};
</script>

<style lang="scss" scoped>
#video {
  width: 100%;
  height: 100%;
}
</style>
<style lang='scss'>
#orderlist {
  .el-dialog__wrapper {
    .video_call_modal {
      width: 418px !important;
      // margin-top: 5vh !important;
      // &>.el-dialog__header{
      //   display: none;
      // }
    }
  }
  .video_call_modal {
    .el-dialog {
      width: 418px !important;
    }
    .el-dialog__body,
    .el-dialog__footer {
      background: #fff;
      margin: 0;
    }
    .el-dialog__body {
      // padding: 20px 24px !important;
      padding: 20px 24px !important;
    }
    .el-dialog__header {
      height: 54px;
      padding: 19px 24px !important;
      background: #f9fafa;
      .el-dialog__title {
        font-size: 16px;
        line-height: 16px;
      }
      .el-dialog__headerbtn {
        top: 16px;
      }
    }
  }
}
</style>
